import { render } from "./WhyPartnerTwo.vue?vue&type=template&id=c6a98b8e&scoped=true"
import script from "./WhyPartnerTwo.vue?vue&type=script&lang=js"
export * from "./WhyPartnerTwo.vue?vue&type=script&lang=js"

import "./WhyPartnerTwo.vue?vue&type=style&index=0&id=c6a98b8e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6a98b8e"]])

export default __exports__